export default __webpack_public_path__ + "static/media/icon-alert.f59d8e7c.svg";